"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMyFortum = function IconMyFortum(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M30.995 9.783A5 5 0 0 0 26 5H12l-.217.005A5 5 0 0 0 7 10v28l.005.217A5 5 0 0 0 12 43h11v-2H12l-.176-.005A3 3 0 0 1 9 38v-2.03h13v-1H9V10l.005-.176A3 3 0 0 1 12 7h14l.176.005A3 3 0 0 1 29 10v5h2v-5zM21 9.97v1h-4v-1zm16 7h-7a5 5 0 0 0-5 5v16a5 5 0 0 0 5 5h7a5 5 0 0 0 5-5v-16a5 5 0 0 0-5-5m-7 2h7a3 3 0 0 1 3 3v15H27v-15a3 3 0 0 1 3-3m-3 19h13a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3m8-16v-1h-3v1zM18.62 39.2a.95.95 0 1 0 0-1.9.95.95 0 0 0 0 1.9m15.42.36a.64.64 0 1 1-1.28 0 .64.64 0 0 1 1.28 0m1.13-8.86.014.025A2 2 0 1 1 33.19 27.3l.21-.78-.78-.21a3.12 3.12 0 1 0 3.12 5.39l-.556-.975.006-.005zm-.761.052a1.75 1.75 0 0 1-1.739-.882 1.76 1.76 0 0 1 .65-2.37 1.75 1.75 0 1 1 1.089 3.252M21.47 25.55l.93 1.6a5.051 5.051 0 0 1-5.05-8.75l1.27.34-.35 1.26a3.2 3.2 0 1 0 3.2 5.54zm-1.236.061A2.83 2.83 0 0 1 17.42 24.2a2.85 2.85 0 0 1 1.05-3.85 2.83 2.83 0 1 1 1.764 5.261",
    clipRule: "evenodd"
  })));
};

export { IconMyFortum, IconMyFortum as default };
